import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Avatar,
  Card,
  CardContent,
  Input,
  CircularProgress,
  Tabs,
  Tab
} from '@mui/material';
import Swal from 'sweetalert2';
import { useParams, useNavigate } from 'react-router-dom';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { toast,ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../../../AuthProvider';
import dayjs from 'dayjs';
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";


const baseUrl = process.env.REACT_APP_API_BASE_URL;
function PrincipalDetails() {
  const { empId } = useParams();
  const { oId } = useAuth();
  console.log("I AM EMPLOYEE ID :"+empId);
  const [employee, setEmployee] = useState('');
  const [isEditing, setIsEditing] = useState({ 0: false, 1: false, 2: false, 3: false });
  const [loader, setLoader] = useState(true);
  const [buttonLoader, setButtonLoader] = useState(false);  // State for button loader
  const [employeeData, setEmployeeData] = useState({

    //Basic Details
    prefix: '',
    firstName: '',
    lastName: '',
    emailId: '',
    contactNumber1: '',
    dateofBirth:'',
    workEmail: '',
    joiningDate: '',
    hno: '',
    city: '',
    state: '',
    bloodGroup:'',
    nationality: '',
    gender: '',
    //Personal Deatils
    panNumber: '',
    aadharNumber: '',
    passportNo: '',
    motherName: "",
    fatherName: "",
    contactNumber2: "",
    uan: "",
    maritalStatus: "",
    //Professional experience
    previousSchoolName: "",
    previousExperience: "",
    department: "",
    designation: "",
    currentCtc: "",
    higherQualification: "",
    //Bank details
    bankName: "",
    bankAccount: "",
    ifscCode: "",
    bankBranch: "",

    //Documents
    profilePic: null,
    document1: null,
    document2: null,
    document3: null,
  });
  const [tabData, setTabData] = useState({
    0: {},
    1: {},
    2: {},
    3: {},
    4: {}
  });
  const [profilePic, setProfilePic] = useState(null);
  const [document1, setDocument1] = useState(null);
  // const [document2, setDocument2] = useState(null);
  // const [document3, setDocument3] = useState(null);
 
  const [tabIndex, setTabIndex] = useState(0); // Manage active tab
  const navigate = useNavigate();

  useEffect(() => {
    fetchEmployee();
  }, [empId]);

  const fetchEmployee = async () => {
    try {
      setLoader(true);
      const response = await fetch(`${baseUrl}/api/v1/organisation/getById/${empId}`);
      const data = await response.json();
      setEmployee(data);
      setEmployeeData((prevData) => ({
        ...prevData,
        ...data
      }));
      // Initialize tab-specific data
      setTabData({
        0: {  prefix: data.prefix, 
              firstName: data.firstName, 
              lastName: data.lastName,
              emailId: data.emailId,
              contactNumber1: data.contactNumber1,
              dateofBirth: data.dateofBirth,
              workEmail: data.workEmail,
              joiningDate: data.joiningDate,
              hno: data.hno,
              city: data.city,
              state: data.state,
              bloodGroup: data.bloodGroup,
              nationality: data.nationality,
              gender: data.gender,
         },
        1: { 
              panNumber: data.panNumber,
              aadharNumber: data.aadharNumber,
              passportNo: data.passportNo,
              motherName: data.motherName,
              fatherName: data.fatherName,
              contactNumber2: data.contactNumber2,
              uan: data.uan,
              maritalStatus: data.maritalStatus,
            },
        2: { 
          previousSchoolName: data.previousSchoolName,
              previousExperience: data.previousExperience,
              department: data.department,
              designation: data.designation,
              currentCtc: data.currentCtc,
              higherQualification:data.higherQualification,
            },
        3: { 
              bankName: data.bankName,
              bankAccount: data.bankAccount,
              ifscCode: data.ifscCode,
              bankBranch: data.bankBranch,
            },
        4: { 
          profilePic: data.profilePic,
          document1: data.document1,
          document2: data.document2,
          document3: data.document3,
            },
      });
    } catch (error) {
      console.error('Error fetching employee:', error);
    } finally {
      setLoader(false);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setTabData((prevData) => ({
      ...prevData,
      [tabIndex]: {
        ...prevData[tabIndex],
        [name]: value
      }
    }));
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (name === 'profilePic') {
      setProfilePic(files[0]);
    } else if (name === 'document1') {
      setDocument1(files[0]);
    }
    //  else if (name === 'document2') {
    //   setDocument2(files[0]);
    // } else if (name === 'document3') {
    //   setDocument3(files[0]);
    // }
  };


  

  //new handle save method
  const handleSave = async () => {
    setButtonLoader(true);  // Start the button loader
    const dataToSend = { ...tabData[tabIndex] };
  
    try {
      if (tabIndex === 4) {
        await handleFileUploadAndSave();
      } else {
        await updateEmployeeData(dataToSend);
      }
  
      // If the data update is successful
      // Swal.fire({
      //   title: 'Success',
      //   text: 'Employee Details updated successfully!',
      //   icon: 'success',
      //   confirmButtonText: 'OK'
      // });
  
      // Show success toast notification
      toast.success("Principal details updated successfully!", {
        position: "top-right",
        autoClose: 1000
      });
  
    } catch (error) {
      // If there's an error during the update
      // Swal.fire({
      //   title: 'Error',
      //   text: 'Failed to update Employee Details!',
      //   icon: 'error',
      //   confirmButtonText: 'OK'
      // });
  
      // Show error toast notification
      toast.error("Failed to update employee details!", {
        position: "top-right",
        autoClose: 1000
      });
    } finally {
      setButtonLoader(false);  // Stop the button loader
    }
  };
  
  
 const updateEmployeeData = async (dataToSend) => {
  try {
    const formattedData = { ...dataToSend };

    if (formattedData.dateofBirth) {
      formattedData.dateofBirth = dayjs(formattedData.dateofBirth).format("YYYY-MM-DD");
    }

    const response = await fetch(`${baseUrl}/api/v1/organisation/principal/update/${empId}/${oId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formattedData),
    });

    if (response.ok) {
      setIsEditing((prev) => ({ ...prev, [tabIndex]: false }));
      fetchEmployee(); // Refresh the employee data
      // toast.success("Data updated successfully!", { position: "top-right",autoClose: 1000 });
    } else {
      console.error('Failed to update employee data');
      // toast.error("Failed to update employee data", { position: "top-right",autoClose: 1000 });
    }
  } catch (error) {
    console.error('Error:', error);
    // toast.error("Error updating data", { position: "top-right",autoClose: 1000 });
  }
};

  
  const handleFileUploadAndSave = async () => {
    const formData = new FormData();
  
    // Add other fields from tabData[tabIndex] to formData
    Object.keys(tabData[tabIndex]).forEach(key => {
      if (tabData[tabIndex][key] !== null) {
        formData.append(key, tabData[tabIndex][key]);
      }
    });
  
    // Add profile pic and documents to formData if they exist
    if (profilePic) formData.append('profilePic', profilePic);
    if (document1) formData.append('document1', document1);
    // if (document2) formData.append('document2', document2);
    // if (document3) formData.append('document3', document3);
  
    try {
      const response = await fetch(`${baseUrl}/api/v1/organisation/update/PrincipalDocuments/${empId}/${oId}`, {
        method: 'PUT',
        body: formData,
      });
  
      if (response.ok) {
        setIsEditing((prev) => ({ ...prev, [tabIndex]: false }));
        fetchEmployee(); // Refresh the employee data
        // toast.success("Files uploaded and data updated!", { position: "top-right",autoClose: 1000 });
      } else {
        console.error('Failed to upload files and update employee data');
        // toast.error("Failed to upload files", { position: "top-right",autoClose: 1000 });
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error("Error uploading files", { position: "top-right" ,autoClose: 1000});
    }
  };
  
  
  

  const handleEditClick = () => {
    setIsEditing((prev) => ({ ...prev, [tabIndex]: true }));
  };

  const handleCancelClick = () => {
    setIsEditing((prev) => ({ ...prev, [tabIndex]: false }));
    setTabData((prevData) => ({ ...prevData, [tabIndex]: employee }));
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };


  // Function to format field names with each word's first letter capitalized
  // const formatFieldName = (field) => {
  //   return field
  //     .replace(/([A-Z])/g, ' $1')  // Insert space before capital letters
  //     .replace(/^./, str => str.toUpperCase())  // Capitalize the first letter of the entire string
  //     .replace(/\b\w/g, char => char.toUpperCase());  // Capitalize the first letter of each word
  // };

  const formatFieldName = (field) => {
    // Special cases for certain field names
    switch (field) {
      case 'dateofBirth':
        return 'Date of Birth';
      case 'emailId':
        return 'Email ID';
      case 'contactNumber1':
        return 'Contact Number';
      case 'hno':
        return 'House Number';
      case 'uan':
          return 'UAN';
      case 'ifscCode':
          return 'IFSC Code';
      default:
        // Default behavior: capitalize the first letter of each word, and add spaces before capital letters
        return field
          .replace(/([A-Z])/g, ' $1')  // Insert space before capital letters
          .replace(/^./, str => str.toUpperCase())  // Capitalize the first letter of the entire string
          .replace(/\b\w/g, char => char.toUpperCase());  // Capitalize the first letter of each word
    }
  };

  return (
    <Box margin={2}>
      {/* {loader ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      ) : (
        employee && ( */}
          <Card sx={{ backgroundColor: 'white', boxShadow: 1, marginTop: 12 }}>
            <CardContent>
            
              <Box display="flex" alignItems="center" justifyContent="space-between" mb={4}>
              
                <Box display="flex" alignItems="center">
                <ArrowBackIcon
                style={{
                  // marginRight: isMobile ? 0 : 15, // Adjust margin on mobile and desktop
                  fontSize: "35px", // Adjust size as needed
                  cursor:'pointer',
                  marginBottom:"1%"
                }}

                onClick={() => navigate(-1)}
              />
              {/* Profile PIc AND Employee Name  */}
                  <Avatar
                    alt={`${employee.firstName} ${employee.lastName}`}
                    src={`data:image/jpeg;base64,${employee.profilePic}`}
                    sx={{ width: 70, height: 70}}
                  />
                  <Box sx={{ ml:1 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: 22 }}>
                      {employee.firstName} {employee.lastName}
                    </Typography>
                    <Typography variant="h5" sx={{ fontSize: 15 }}>
                      {employee.employeeId}
                    </Typography>
                  </Box>
                </Box>

                {/* <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#3C3972",
                    color: "#fff",
                    "&:hover": { backgroundColor: "#3C3972" },
                    fontWeight: "bold",
                  }}
                  onClick={() => navigate(`/EmployeeAttendanceDetails/${empId}`)}
                >
                  View Attendance
                </Button> */}
              </Box>

              <Tabs value={tabIndex} onChange={handleTabChange} aria-label="employee details tabs">
                <Tab label="Basic Details" sx={{ fontWeight: 'bold' }}  />
                <Tab label="Personal Details" sx={{ fontWeight: 'bold' }}  />
                <Tab label="Professional experience" sx={{ fontWeight: 'bold' }} />
                <Tab label="Bank Details" sx={{ fontWeight: 'bold' }} />
                <Tab label="Other Details" sx={{ fontWeight: 'bold' }} />
              </Tabs>

              <Grid container spacing={2} mt={2}>
                {tabIndex === 0 && (
                  <>
                    {/* Basic Details Tab */}
                   {[
  "prefix",
  "firstName",
  "lastName",
  "emailId",
  "contactNumber1",
  "dateofBirth",
  "workEmail",
  "joiningDate",
  "hno",
  "city",
  "state",
  "bloodGroup",
  "nationality",
  "gender",
].map((field) => {
  const rawValue = tabData[tabIndex][field] || "";

  const getDateObjFromString = (str) => {
    if (!str) return null;
    if (/^\d{8}$/.test(str)) {
      const yyyy = str.slice(0, 4);
      const mm = str.slice(4, 6);
      const dd = str.slice(6, 8);
      return new Date(`${yyyy}-${mm}-${dd}`);
    }
    if (/^\d{2}-\d{2}-\d{4}$/.test(str)) {
      const [dd, mm, yyyy] = str.split("-");
      return new Date(`${yyyy}-${mm}-${dd}`);
    }
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
      return new Date(str);
    }
    return null;
  };

  const handleDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      const formatted = format(date, "yyyyMMdd");
      setTabData((prev) => ({
        ...prev,
        [tabIndex]: {
          ...prev[tabIndex],
          dateofBirth: formatted,
        },
      }));
    }
  };

  const handleNumberInput = (e) => {
    const { name, value } = e.target;
    if (name === "contactNumber1") {
      if (!value.startsWith("91")) return;
      const afterPrefix = value.slice(2);
      if (/^\d*$/.test(afterPrefix) && value.length <= 12) {
        handleChange(e);
      }
    } else {
      handleChange(e);
    }
  };

  const displayValue =
    field === "dateofBirth" && rawValue.length === 8
      ? `${rawValue.slice(0, 4)}-${rawValue.slice(4, 6)}-${rawValue.slice(6, 8)}`
      : rawValue || "N/A";

  return (
    <Grid item xs={12} sm={6} key={field}>
      <Box mb={2}>
        <Typography
          sx={{
            fontSize: 16,
            backgroundColor: "#dcf5f4",
            padding: 2,
          }}
        >
          <strong>{formatFieldName(field)}:</strong>{" "}
          {isEditing[tabIndex] ? (
            field === "dateofBirth" ? (
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Date of Birth"
                  value={getDateObjFromString(rawValue)}
                  onChange={handleDateChange}
                  format="yyyy/MM/dd"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      size: "small",
                      sx: {
                        backgroundColor: "#dcf5f4",
                        marginTop: "4px",
                      },
                    },
                  }}
                />
              </LocalizationProvider>
            ) : field === "contactNumber1" ? (
              <TextField
                name={field}
                type="text"
                value={
                  rawValue.startsWith("91")
                    ? rawValue
                    : rawValue
                    ? "91" + rawValue
                    : "91"
                }
                onChange={handleNumberInput}
                variant="outlined"
                size="small"
                fullWidth
              />
            ) : (
              <TextField
                name={field}
                value={rawValue}
                onChange={handleChange}
                variant="outlined"
                size="small"
                fullWidth
              />
            )
          ) : (
            displayValue
          )}
        </Typography>
      </Box>
    </Grid>
  );
})}

                  </>
                )}
                {tabIndex === 1 && (
                  <>
                    {/* Personal Details Tab */}
                    {['panNumber','aadharNumber','passportNo','uan','contactNumber2','fatherName','motherName','maritalStatus',].map((field) => (
                      <Grid item xs={12} sm={6} key={field}>
                        <Box mb={2}>
                          <Typography
                            sx={{
                              fontSize: 16,
                              backgroundColor: '#dcf5f4',
                              padding: 2
                            }}
                          >
                            <strong>{formatFieldName(field)}:</strong>{' '}
                            {isEditing[tabIndex] ? (
                              <TextField
                                name={field}
                                value={tabData[tabIndex][field] || ''}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                fullWidth
                              />
                            ) : (
                              tabData[tabIndex][field]
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </>
                )}
                {tabIndex === 2 && (
                  <>
                    {/* Professional Experience Tab */}
                    {[
                        'previousSchoolName',
                        'previousExperience',
                        'department',
                        'designation',
                        'currentCtc',
                        'higherQualification',

                    ].map((field) => (
                      <Grid item xs={12} sm={6} key={field}>
                        <Box mb={2}>
                          <Typography
                            sx={{
                              fontSize: 16,
                              backgroundColor: '#dcf5f4',
                              padding: 2
                            }}
                          >
                            <strong>{formatFieldName(field)}:</strong>{' '}
                            {isEditing[tabIndex] ? (
                              <TextField
                                name={field}
                                value={tabData[tabIndex][field] || ''}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                fullWidth
                              />
                            ) : (
                              tabData[tabIndex][field]
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </>
                )}
                {tabIndex === 3 && (
                  <>
                    {/* Bank Details Tab */}
                    {['bankName','bankAccount','ifscCode','bankBranch',].map((field) => (
                      <Grid item xs={12} sm={6} key={field}>
                        <Box mb={2}>
                        <Typography
                            sx={{
                              fontSize: 16,
                              backgroundColor: '#dcf5f4',
                              padding: 2
                            }}
                          >
                            <strong>{formatFieldName(field)}:</strong>{' '}
                            {isEditing[tabIndex] ? (
                              <TextField
                                name={field}
                                value={tabData[tabIndex][field] || ''}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                fullWidth
                              />
                            ) : (
                              tabData[tabIndex][field]
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </>
                )}
                {tabIndex === 4 && (
                  <>
                    {/* Other Details Tab */}
                    {['profilePic',].map((field) => (
                      <Grid item xs={12} sm={6} key={field}>
                        <Box mb={2}>
                          <Typography
                            sx={{
                              fontSize: 16,
                              backgroundColor: '#dcf5f4',
                              padding: 2,
                            }}
                          >
                            <strong>{formatFieldName(field)}:</strong>{' '}
                            {isEditing[tabIndex] ? (
                              <Input
                                type="file"
                                name={field}
                                onChange={handleFileChange}
                                fullWidth
                              />
                            ) : (
                              // tabData[tabIndex][field] && tabData[tabIndex][field].name 
                              //   ? tabData[tabIndex][field].name 
                              //   : 'No file uploaded'
                              field === 'profilePic' && tabData[tabIndex][field]
                                  ? <Avatar src={`data:image/jpeg;base64,${employee.profilePic}`} sx={{ width: 120, height: 120 }} />
                                  : 'No file uploaded'
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </>
                )}


              </Grid>

              <Box mt={2} sx={{display:'flex', justifyContent:'flex-end'}}>
                {isEditing[tabIndex] ? (
                  <>
                    {/* <Button onClick={handleSave} color="primary" variant="contained" sx={{ mr: 2 }}>
                      Save
                    </Button> */}
                    <Button onClick={handleCancelClick} sx={{ mr: 2 }} variant="outlined" ml="10px">
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      sx={{color: "#fff", backgroundColor:'#3C3972', "&:hover": { backgroundColor: "#3C3972" }, }}
                      onClick={handleSave}
                      disabled={buttonLoader}  // Disable button while loading
                    >
                      {buttonLoader ? (
                        <CircularProgress size={24} sx={{ color: "#fff" }} />
                      ) : (
                        "Save"
                      )}
                  </Button>

                    
                  </>
                ) : (
                  <Button onClick={handleEditClick} sx={{color:'#fff',backgroundColor:'#3C3972', "&:hover": { backgroundColor: "#3C3972" },}} variant="contained">
                    Edit
                  </Button>
                )}
              </Box>
            </CardContent>
          </Card>
        {/* )
      )} */}
      <ToastContainer />
    </Box>
  );
}

export default PrincipalDetails;
